import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { useForm ,useWatch  } from 'react-hook-form'
import { _files } from 'src/_mock'
import { ConfirmDialog } from 'src/components/custom-dialog'
import FormProvider, { RHFSelect, RHFTextField } from 'src/components/hook-form'
import Iconify from 'src/components/iconify'
import { useBoolean } from 'src/hooks/use-boolean'
import { useGetCategoriesQuery } from 'src/store/Reducer/category'
import { useGetFoldersQuery, useMoveFolderMutation } from 'src/store/Reducer/folder'
import { useSnackbar } from 'src/components/snackbar';
import * as Yup from 'yup'
import { useLazyGetFilesQuery } from 'src/store/Reducer/file'
import { useBackToClose } from 'src/hooks/use-back-to-close';

const QuickMoveModal = ({selectedImages,setSelectedImages,setShowImageSelection, setItemState ,item, open, onClose }) => {
  useBackToClose(open, onClose); // browser / mouse Back closes this dialog

    const show = useBoolean();
    const confirm = useBoolean();
    const { enqueueSnackbar } = useSnackbar();
    const [moveFolder, { isLoading: moving }] = useMoveFolderMutation();
    const [triggerGetFiles] =  useLazyGetFilesQuery();
    const {data: { data = []} = {}} = useGetCategoriesQuery({page: 0, limit: 1000 , search: '', status: 'active'});

    const defaultValues = useMemo(
      () => ({
        category: '',
        target_folder_id: '',
        new_folder_name: '',
      }),
      []
    );
    const schema = Yup.object().shape({
    category: Yup.string().required('Category is required'),
    ...(show.value
      ? { new_folder_name: Yup.string().required('New folder name is required') }
      : { target_folder_id: Yup.string().required('Target folder is required') }),
  });
    const methods = useForm({
        defaultValues,
        resolver: yupResolver(schema)
    })
    const {
        control,
        handleSubmit,
        formState: { isSubmitting }
    } = methods;
    const selectedCategoryId = useWatch({ control, name: 'category' });
    const {
    data: { data: folders = [] } = {},
  } = useGetFoldersQuery(
    { id: selectedCategoryId , limit : 1000 },
    { skip: !selectedCategoryId }
  );

    useEffect(()=>{
        methods.reset(defaultValues)
    },[defaultValues])

    const onSubmit = async (formData) => {
        confirm.onTrue();
         methods.setValue('pendingData', formData);
    }
    
    
  const handleMoveConfirm = async () => {
    try {
      const formData = methods.getValues();
       const selectedIds = selectedImages?.map((img) => img?.id)
      const payload = {
        ids: selectedIds,
        category_id: formData.category,
        ...(show.value
          ? { new_folder_name: formData.new_folder_name }
          : { target_folder_id: formData.target_folder_id }),
      };
      const response = await moveFolder(payload).unwrap();
      const resp = await triggerGetFiles({category:formData?.category,folder:response?.data?.target_folder_id}).unwrap();
            setItemState((prev) => ({
        ...prev,
        data: resp?.data?.data || [],
      }));
      enqueueSnackbar('Files moved successfully!', { variant: 'success' });
      setSelectedImages([]);
      setShowImageSelection(false);
      confirm.onFalse();
      onClose();
    } catch (error) {
      enqueueSnackbar(error?.data?.message || 'Failed to move Files', {
        variant: 'error',
      });
    }
  };


    return (
      <>
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
          <DialogTitle>Move</DialogTitle>
          <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <DialogContent>
              <Box
                sx={{
                  display: 'flex',
                  gap: 3,
                  flexDirection: 'column',
                  mt: 2,
                }}
              >
                <RHFSelect
                  name="category"
                  label="Category"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    methods.setValue('category', newValue);
                    methods.setValue('new_folder_name', '');
                    methods.setValue('target_folder_id', '');
                  }}
                >
                  {data?.map((category) => (
                    <MenuItem key={category?.id} value={category?.id}>
                      {category?.title}
                    </MenuItem>
                  ))}
                </RHFSelect>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {show.value ? (
                    <RHFTextField name="new_folder_name" label="Folder Name" fullWidth />
                  ) : (
                    <RHFSelect name="target_folder_id" label="Folder">
                      {folders?.directory?.map((folder) => (
                        <MenuItem
                          key={folder?.category_folder_id}
                          value={folder?.category_folder_id}
                        >
                          {folder?.project}
                        </MenuItem>
                      ))}
                    </RHFSelect>
                  )}
                  <IconButton
                    onClick={() => {
                      show.onToggle();
                      methods.setValue('folder', '');
                    }}
                  >
                    <Iconify
                      icon={show.value ? 'ph:minus-fill' : 'ph:plus-fill'}
                      sx={{ color: 'primary.main', cursor: 'pointer' }}
                    />
                  </IconButton>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} variant="outlined">
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                Move
              </Button>
            </DialogActions>
          </FormProvider>
        </Dialog>
        <ConfirmDialog
          open={confirm.value}
          onClose={confirm.onFalse}
          title="Are you sure want to move this file?"
          content="If you move this file, it will be removed from the current folder."
          action={
            <Button variant="contained" color="error" onClick={handleMoveConfirm} disabled={moving}>
              {moving ? 'Moving...' : 'Confirm Move'}
            </Button>
          }
        />
      </>
    );
}

export default QuickMoveModal